// Reexport all svg icons
export { default as appStore } from './appStore.svg'
export { default as caret } from './caret.svg'
export { default as googlePlay } from './googlePlay.svg'
export { default as instagram } from './instagram.svg'
export { default as linkedin } from './linkedin.svg'
export { default as minus } from './minus.svg'
export { default as plus } from './plus.svg'
export { default as twitter } from './twitter.svg'
